export const CustomInput = ({
  label,
  value,
  onChange,
  isDisabled,
  toggleEdit,
  placeholder = "Enter price here",
  validationError,
  errorMessage = "Please enter a valid value",
  type = "currency",
}) => {
  const displayValue = isDisabled
    ? `${type === "currency" ? "£" : ""}${value}${
        type === "percentage" ? "%" : ""
      }`
    : value;

  console.log("validationError", label, validationError);

  return (
    <div className="w-full">
      <div className="flex justify-between items-center w-full mb-2">
        <label
          htmlFor={label}
          className="2xl:text-[17px] xl:text-[15px] lg:text-[14px] font-semibold text-[#413F3F]"
        >
          {label}
        </label>
        <button
          type="button"
          className="font-medium text-primary 2xl:text-[17px] xl:text-[15px] lg:text-[14px]"
          onClick={toggleEdit}
          aria-label={isDisabled ? "Enable editing" : "Save changes"}
        >
          {isDisabled ? "Edit" : "Save"}
        </button>
      </div>
      <input
        id={label}
        type="text"
        value={displayValue}
        onChange={onChange}
        disabled={isDisabled}
        placeholder={placeholder}
        className={`border-[1px] focus-within:border-[1px] focus-within:outline-[1px] rounded-md w-full shadow-light px-3 py-[9px] placeholder:font-normal outline-primary text-base font-medium my-1 ${
          isDisabled ? "bg-gray-100" : "bg-white border-red-500"
        } ${
          validationError && value === ""
            ? "border-red-500 bg-white"
            : "border-[#00000029]"
        }`}
      />
      {validationError && value === "" && (
        <span className="text-red-600 text-sm">{errorMessage}</span>
      )}
    </div>
  );
};
